import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-question-sort-dialog',
  templateUrl: './manual-question-sort-dialog.component.html',
  styleUrls: ['./manual-question-sort-dialog.component.css'],
  standalone: false,
})
export class ManualQuestionSortDialogComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;

  currentLang: string = 'ja';
  
  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
